<template>
  <q-page fluid class="row questionnaire content-start q-pa-xl">
    <div class="col-12" v-if="tab != 0" style="height: 45px">
      <q-btn round flat @click="previousQuestion()">
        <q-icon name="arrow_back" size="xl" class="text-faintGrey"></q-icon>
      </q-btn>
    </div>

    <q-tab-panels
      v-model="tab"
      class="col-12"
      animated
      transition-prev="slide-right"
      transition-next="slide-left"
    >
      <q-tab-panel :name="0">
        <div class="row">
          <div class="col-12 q-pa-lg">
            <h3 class="text-weight-light text-accent">Getting Started</h3>
            <h5 class="text-weight-light text-faintGrey">
              Please fill out the following to begin
            </h5>
          </div>

          <q-form class="col-12 row" ref="personalForm">
            <div class="col-12 col-md-9 row">
              <div class="col-12 col-sm-6 q-pa-lg">
                <label for="fullName" class="text-faintGrey">Full Name *</label>
                <q-input
                  outlined
                  id="fullName"
                  v-model="userFormData.fullName"
                  required
                  :rules="[
                    (val) => checkValEmpty(val, 'string') || 'Field empty!',
                  ]"
                ></q-input>
              </div>

              <div class="col-12 col-sm-6 q-pa-lg">
                <label for="phoneNumber" class="text-faintGrey" required
                  >Phone Number</label
                >
                <q-input
                  outlined
                  id="phoneNumber"
                  v-model="userFormData.phone"
                ></q-input>
              </div>
              <div class="col-12 col-sm-12 q-pa-lg">
                <label for="email" class="text-faintGrey" required
                  >Email Address</label
                >
                <q-input
                  outlined
                  type="email"
                  id="email"
                  v-model="userFormData.email"
                  required
                  readonly
                  :rules="[
                    (val) => checkValEmpty(val, 'string') || 'Field empty!',
                  ]"
                ></q-input>
              </div>
              <div
                v-if="
                  currentUserData.role &&
                  currentUserData.role.length == 1 &&
                  currentUserData.role[0] == 'user'
                "
                class="col-12 q-pa-lg"
              >
                <label for="businessName" class="text-faintGrey"
                  >Business Name</label
                >
                <q-input
                  outlined
                  id="businessName"
                  v-model="company.businessName"
                  required
                  :rules="[
                    (val) => checkValEmpty(val, 'string') || 'Field empty!',
                  ]"
                ></q-input>
              </div>
            </div>
            <div class="col-12 col-md-3 q-px-lg">
              <q-btn
                color="primary"
                class="text-uppercase full-width full-height"
                @click="updateQuestionnaire(0)"
                :loading="personalFormLoading"
              >
                <h2 class="text-weight-bold">LETS GO</h2>
              </q-btn>
            </div>
          </q-form>
        </div>
      </q-tab-panel>

      <q-tab-panel :name="1">
        <div class="row">
          <div class="col-12 q-pa-lg">
            <h3 class="text-weight-light text-accent">Getting Started</h3>
            <h5 class="text-weight-light text-faintGrey">
              Where is your company located?
            </h5>
          </div>

          <q-form
            class="col-12 row"
            ref="companyForm"
            @submit="validateForm('details')"
          >
            <div class="col-12 col-md-9 row">
              <div class="col-12 q-pa-lg">
                <label for="address1" class="text-faintGrey">Address 1</label>
                <q-input
                  outlined
                  id="address1"
                  v-model="company.address1"
                  required
                  :rules="[
                    (val) => checkValEmpty(val, 'string') || 'Field empty!',
                  ]"
                ></q-input>
              </div>
              <div class="col-12 q-pa-lg q-mb-sm">
                <label for="address2" class="text-faintGrey">Address 2</label>
                <q-input
                  outlined
                  id="address2"
                  v-model="company.address2"
                ></q-input>
              </div>
              <div class="col-12 col-sm-6 q-pa-lg">
                <label for="city" class="text-faintGrey">City</label>
                <q-input
                  outlined
                  id="city"
                  v-model="company.city"
                  required
                  :rules="[
                    (val) => checkValEmpty(val, 'string') || 'Field empty!',
                  ]"
                ></q-input>
              </div>
              <div class="col-12 col-sm-6 q-pa-lg">
                <label for="postcode" class="text-faintGrey" required
                  >Postcode</label
                >
                <q-input
                  outlined
                  id="postcode"
                  v-model="company.postcode"
                  required
                  :rules="[
                    (val) =>
                      checkValEmpty(val, 'postcode') ||
                      'Please enter 4 characters!',
                  ]"
                ></q-input>
              </div>
            </div>
            <div class="col-12 col-md-3 q-px-lg">
              <q-btn
                color="primary"
                class="text-uppercase full-width full-height"
                @click="updateQuestionnaire(1)"
              >
                <h2 class="text-weight-bold">LETS GO</h2>
              </q-btn>
            </div>
          </q-form>
        </div>
      </q-tab-panel>

      <q-tab-panel :name="2">
        <q-form ref="sizeForm" @submit="validateForm('size')">
          <div class="row">
            <div class="col-12 q-pa-lg">
              <h5 class="text-weight-light text-faintGrey">
                How many people in your company?
              </h5>
            </div>
            <div class="col-12 col-md-3 q-pa-lg">
              <q-input
                outlined
                required
                v-model="company.size"
                :rules="[(val) => val != null || 'Field empty!']"
              ></q-input>
            </div>
            <div class="col-12 col-md-2 q-pa-lg">
              <q-btn
                color="primary"
                size="lg"
                class="text-capitalize full-width"
                @click="updateQuestionnaire(2)"
              >
                Next
              </q-btn>
            </div>
          </div>
        </q-form>
      </q-tab-panel>

      <q-tab-panel :name="3">
        <div class="row">
          <div class="col-12 q-pa-lg">
            <h5 class="text-weight-light text-faintGrey">
              Do you rely on gas water heating at your business?
            </h5>
          </div>
          <div class="col-12 col-md-4 q-pa-md">
            <q-btn-group class="no-shadow no-border-radius full-width column">
              <q-btn
                outline
                size="lg"
                class="
                  text-faintGrey text-capitalize
                  full-width
                  q-mb-xl
                  border-radius-3
                "
                :class="{
                  'bg-accent': company.power,
                  'text-white': company.power,
                }"
                @click="
                  company.power = 1;
                  updateQuestionnaire();
                "
              >
                Yes
              </q-btn>
              <q-btn
                outline
                size="lg"
                class="text-faintGrey text-capitalize full-width"
                :class="{
                  'bg-accent': !company.power && company.power != null,
                  'text-white': !company.power && company.power != null,
                }"
                @click="
                  company.power = 0;
                  updateQuestionnaire();
                "
              >
                No
              </q-btn>
            </q-btn-group>
          </div>
        </div>
      </q-tab-panel>

      <q-tab-panel :name="4">
        <div class="row">
          <div class="col-12 q-pa-lg">
            <h5 class="text-weight-light text-faintGrey">
              What percentage of your site’s water is sourced from
              rainwater/borewater tanks?
            </h5>
          </div>
          <div class="col-12 col-md-4 q-pa-md">
            <q-btn
              outline
              size="lg"
              class="text-faintGrey text-capitalize full-width q-mb-xl"
              @click="
                company.water = option;
                updateQuestionnaire();
              "
              v-for="(option, index) in q3Options"
              :key="index"
              :class="{
                'bg-accent': company.water == option,
                'text-white': company.water == option,
              }"
            >
              {{ option }}
            </q-btn>
          </div>
        </div>
      </q-tab-panel>

      <q-tab-panel :name="5">
        <div class="row">
          <div class="col-12 q-pa-lg">
            <h5 class="text-weight-light text-faintGrey">
              Do you compost your food waste?
            </h5>
          </div>
          <div class="col-12 col-md-4 q-pa-md">
            <q-btn
              outline
              size="lg"
              class="text-faintGrey text-capitalize full-width q-mb-xl"
              @click="
                company.waste = true;
                updateQuestionnaire();
              "
              :class="{
                'bg-accent': company.waste,
                'text-white': company.waste,
              }"
            >
              Yes
            </q-btn>
            <q-btn
              outline
              size="lg"
              class="text-faintGrey text-capitalize full-width"
              @click="
                company.waste = 0;
                updateQuestionnaire();
              "
              :class="{
                'bg-accent': !company.waste && company.waste != null,
                'text-white': !company.waste && company.waste != null,
              }"
            >
              No
            </q-btn>
          </div>
        </div>
      </q-tab-panel>

      <q-tab-panel :name="6">
        <div class="row justify-center">
          <div class="col-12 q-pa-lg">
            <h3 class="text-weight-light text-accent q-my-none">Thank you!</h3>
            <h5 class="text-weight-light text-faintGrey q-my-md">
              Here are some suggested solutions based off your answers.
            </h5>
            <h5 class="text-weight-bold text-accent q-my-none">
              (You don't have to choose these)
            </h5>
          </div>

          <div
            class="col-6 col-md-3 text-center"
            v-for="(solution, index) in solutions"
            :key="index"
          >
            <q-card
              class="q-mx-lg"
              :class="{ 'bg-accent': solution.hover == true }"
              @mouseover="solution.hover = true"
              @mouseleave="solution.hover = false"
            >
              <q-tab-panels
                v-model="solution.hover"
                animated
                transition-prev="slide-down"
                transition-next="slide-up"
              >
                <q-tab-panel :name="false">
                  <q-card-section v-if="solution.hover == false">
                    <q-img :src="solution.img"></q-img>
                  </q-card-section>
                  <q-card-section>
                    <h5 class="text-weight-bold text-accent q-ma-none">
                      {{ solution.title }}
                    </h5>
                    <h6 class="text-weight-light text-accent q-ma-none">
                      {{ solution.desc }}
                    </h6>
                  </q-card-section>
                </q-tab-panel>
                <q-tab-panel
                  :name="true"
                  class="bg-accent row items-center cursor-pointer"
                >
                  <h2 class="text-white">Add to Solutions</h2>
                </q-tab-panel>
              </q-tab-panels>
            </q-card>
          </div>
          <div class="col-6 col-md-3">
            <div class="full-height q-mx-lg">
              <q-btn
                color="primary"
                size="xl"
                class="boldHover text-uppercase full-width full-height"
                @click="$router.push({ path: `/` })"
              >
                <h2>
                  Browse <br />
                  solution <br />
                  centre
                </h2>
              </q-btn>
            </div>
          </div>
        </div>
      </q-tab-panel>
    </q-tab-panels>
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";
  import moment from "moment";

  export default {
    components: {},
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
      }),
    },
    watch: {},
    data: () => ({
      tab: 0,
      personalFormLoading: false,

      userFormData: {
        fullName: null,
        email: null,
        phone: null,
      },

      company: {
        businessName: null,
        address1: null,
        address2: null,
        city: null,
        postcode: null,
        size: null,
        power: null,
        water: null,
        waste: null,
        tab: null,
      },

      q3Options: ["None", "Less than Half", "Half", "All", "Unsure"],
      solutions: [
        {
          title: "Carbon",
          desc: "Cycling for employees",
          img: "img/icons/carbon-1.png",
          hover: false,
        },
        {
          title: "Power",
          desc: "Lights turned off",
          img: "img/icons/energy-1.png",
          hover: false,
        },
        {
          title: "Waste",
          desc: "Food is composed",
          img: "img/icons/waste-1.png",
          hover: false,
        },
      ],
    }),
    mounted() {
      this.checkProgress();
    },
    methods: {
      previousQuestion() {
        this.tab -= 1;
      },
      nextQuestion() {
        this.tab += 1;
      },
      checkValEmpty(val, type) {
        if (val != null) {
          if (type == "string") {
            if (val.length > 0) {
              return true;
            }
          } else if (type == "phone") {
            let numberLengths = [9, 10, 11];
            if (numberLengths.includes(val.length)) {
              return true;
            }
          } else if (type == "postcode") {
            if (val.length == 4) {
              return true;
            }
          }
        }

        return false;
      },
      checkProgress() {
        this.userFormData.fullName = this.currentUserData.fullName;
        this.userFormData.phone = this.currentUserData.phone;
        this.userFormData.email = this.currentUserData.email;

        this.$store
          .dispatch("users/getQuestionnaire", this.currentUserData.id)
          .then((result) => {
            this.tab = result.progress.tab;
            this.company = result.progress;
          });
      },
      updateQuestionnaire(qNum) {
        switch (qNum) {
          case 0:
            this.$refs.personalForm.validate().then((result) => {
              if (result) {
                this.personalFormLoading = true;
                this.company.tab = this.tab + 1;

                // Saving the Questionnaire
                this.$store
                  .dispatch("users/updateQuestionnaire", this.company)
                  .then(() => {
                    // Saving the User Information
                    this.$store
                      .dispatch("users/saveUser", this.userFormData)
                      .then(() => {
                        // Reloading the Users Data
                        this.$store
                          .dispatch("auth/loadCurrentUserData")
                          .then(() => {
                            this.personalFormLoading = false;
                            // If the user does not need to continue with the questionnaire then send to dashboard
                            if (
                              this.currentUserData
                                .sustainabilityQuestionnaireRequired == 0
                            ) {
                              this.$router.push("/");
                            } else {
                              this.nextQuestion();
                            }
                          });
                      });
                  });
              }
            });

            break;
          case 1:
            this.$refs.companyForm.validate().then((result) => {
              if (result) {
                this.company.tab = this.tab + 1;
                this.company.user_id = this.currentUserData.id;
                this.$store.dispatch("users/updateQuestionnaire", this.company);
                this.nextQuestion();
              }
            });

            break;
          case 2:
            this.$refs.sizeForm.validate().then((result) => {
              if (result) {
                this.company.tab = this.tab + 1;
                this.company.user_id = this.currentUserData.id;
                this.$store.dispatch("users/updateQuestionnaire", this.company);
                this.nextQuestion();
              }
            });
            break;
          default:
            this.company.tab = this.tab + 1;
            this.company.user_id = this.currentUserData.id;
            this.$store.dispatch("users/updateQuestionnaire", this.company);
            this.nextQuestion();
            if (this.tab == 5) {
              this.currentUserData.sustainabilityQuestionnaireRequired = 0;
              this.$store.dispatch("users/saveUser", this.currentUserData);
            }
            break;
        }
      },
    },
  };
</script>

<style lang="scss">
  .questionnaire {
    .q-card,
    .q-tab-panel {
      min-height: 500px;
      overflow: hidden;
    }
    .q-btn {
      border-radius: 3px !important;
    }
    .boldHover:hover {
      h2 {
        font-weight: bold !important;
      }
    }
  }
</style>


